module.exports = __webpack_public_path__ + "img/jwlsc1.d2ee96bb.png";